module.exports = __webpack_public_path__ + "img/ruiyan_06.a63348d3.jpg";